import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#030712]" data-testid="auth-loading">
        <span className="font-body text-white/50 text-sm tracking-widest animate-pulse">LOADING…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
